import { render, staticRenderFns } from "./EyedockHeader.vue?vue&type=template&id=a454af18&scoped=true&"
import script from "./EyedockHeader.vue?vue&type=script&lang=js&"
export * from "./EyedockHeader.vue?vue&type=script&lang=js&"
import style0 from "./EyedockHeader.vue?vue&type=style&index=0&id=a454af18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a454af18",
  null
  
)

export default component.exports